<!-- Page Wrapper -->
<div class="page-wrapper" style="min-height: 347px;">
    <div class="content container-fluid">
        <div class="bg-white page-border page-min-h">
            <!--page body contant -->
            <div class="row row-replace add-m-b">
                <div class="col-md-6 col-9 col-p h5"><i class="fa fa-users"></i> DASHBOARD / RELEASE</div>
                <div class="col-md-6 col-3 top-corner-items col-p">
                  <button class="btn btn-primary btn-sm" [routerLink]="['/setups']"><i class="fa fa-arrow-left"></i> Back</button>
                </div>
            </div>

            <div class="row ">
                <div class="col-lg-12 col-md-12 col-sm-12">
                    <ul class="nav nav-tabs nav-tabs-bottom">
                        <li class="nav-item"><a class="nav-link" href="#Release-tab2" data-toggle="tab">Release Group</a></li>
                        <li class="nav-item"><a class="nav-link" href="#Release-tab3" data-toggle="tab">Release Strategy</a></li>
                    </ul>
                </div>
            </div>

            <div class="row tab-content">
                <section class="col-lg-12 tab-pane active" id="Release-tab2">
                   <!--menu-->
                   <div class="row row-replace add-m-b">
                      <div class="col-md-6 col-9 col-p">
                         <button class="btn btn-primary btn-sm" (click)="releaseGroupModal()"><i class="fa fa-plus"></i>Add New</button>
                      </div>
                      <div class="col-md-6 col-3 top-corner-items col-p">
                      </div>
                   </div>
                   <!--end menu-->
                   <div class="row">
                      <div class="col-12">
                         <div class="table-responsive">
                            <table class="table custom-table mb-0">
                               <thead>
                                  <tr>
                                     <th>SR.NO</th>
                                     <th>Release Group</th>
                                     <th>Release Docs</th>
                                  </tr>
                               </thead>
                            </table>
                         </div>
                      </div>
                   </div>
                </section>
                <section class="col-lg-12 tab-pane" id="Release-tab3">
                   <!--form-->
                   <div class="row">
                      <div class="col-md-6">
                         <div class="card-body">
                            <form>
                               <div class="form-group">
                                  <label>Plant Name</label>
                                  <input type="text" class="form-control">
                               </div>
                               <div class="form-group">
                                  <label>Contract Ref</label>
                                  <select class="form-control">
                                     <option>one</option>
                                     <option>one</option>
                                     <option>one</option>
                                  </select>
                               </div>
                               <div class="form-group">
                                  <label>Is Billable</label>
                                  <select class="form-control">
                                     <option>one</option>
                                     <option>one</option>
                                     <option>one</option>
                                  </select>
                               </div>
                            </form>
                         </div>
                      </div>
                      <div class="col-md-6">
                         <div class="card-body">
                            <form>
                               <div class="form-group">
                                  <label>Txn Type</label>
                                  <input type="text" class="form-control">
                               </div>
                               <div class="form-group">
                                  <label>Value Type</label>
                                  <select class="form-control">
                                     <option>one</option>
                                     <option>one</option>
                                     <option>one</option>
                                  </select>
                               </div>
                               <div class="form-group">
                                  <label>Rel Group</label>
                                  <select class="form-control">
                                     <option>one</option>
                                     <option>one</option>
                                     <option>one</option>
                                  </select>
                               </div>
                            </form>
                         </div>
                      </div>
                      <div class="col-12 text-center">
                         <button class="btn btn-success btn-sm">Submit</button>
                      </div>
                   </div>
                   <!--end form-->
                   <!--menu-->
                   <div class="row row-replace add-m-b">
                      <div class="col-md-6 col-9 col-p">
                         <button class="btn btn-primary btn-sm" (click)="releaseStrategyModal()" ><i class="fa fa-plus"></i>Add New</button>
                      </div>
                      <div class="col-md-6 col-3 top-corner-items col-p"></div>
                   </div>
                   <!--end menu-->
                   <div class="row">
                      <div class="col-12">
                         <div class="table-responsive">
                            <table class="table custom-table mb-0">
                               <thead>
                                  <tr>
                                     <th>SR</th>
                                     <th>Contract Ref</th>
                                     <th>Txn Type</th>
                                     <th>Value Type</th>
                                     <th>Is Billable</th>
                                     <th>Payment Terms</th>
                                     <th>Rel Group</th>
                                     <th>Rel Code</th>
                                     <th>Rel Level</th>
                                     <th>Site Name</th>
                                     <th>Emp Id</th>
                                     <th>Effective Date</th>
                                     <th>Expiry Date</th>
                                     <th>Approval Min Amount</th>
                                     <th>Approval Max Amount</th>
                                  </tr>
                               </thead>
                            </table>
                         </div>
                      </div>
                   </div>
                </section>
             </div>
           
        
            <!--end page body contant -->
        </div>
    </div>
</div>
<!-- /Page Wrapper -->



<!--release group modal-->

<div class="modal custom-modal fade" id="release_group" role="dialog" style="display: none;" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">Release Group</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">×</span>
                </button>
            </div>
            <div class="modal-body">
                <form>
                   
                    <div class="form-group">
                        <label>Rel Group<span class="text-danger">*</span></label>
                        <div><input class="form-control" type="text"></div>
                    </div>
                    <div class="form-group">
                        <label>Rel Dese<span class="text-danger">*</span></label>
                        <div><input class="form-control" type="text"></div>
                    </div>
                    <div class="submit-section">
                        <button class="btn btn-primary btn-sm"><i class="fa fa-plus"></i> ADD</button>
                        <button class="btn btn-danger btn-sm m-l-15">CLOSE</button>
                    </div>
                </form>
            </div>
        </div>
    </div>
 </div>
 <!--end release group modal-->


 <!--Release Strategy modal-->

<div class="modal custom-modal fade" id="release_strategy" role="dialog" style="display: none;" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-xl" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">Add New Release Strategy</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">×</span>
                </button>
            </div>
            <div class="modal-body">
                <!--modal body-->
                <div class="row">
                    <div class="col-md-6">
                       <div class="card-body">
                          <form>
                             <div class="form-group">
                                <label>Plant Name</label>
                                <input type="text" class="form-control">
                             </div>
                             <div class="form-group">
                                <label>Contract Ref</label>
                                <select class="form-control">
                                   <option>one</option>
                                   <option>one</option>
                                   <option>one</option>
                                </select>
                             </div>
                             <div class="form-group">
                                <label>Is Billable</label>
                                <select class="form-control">
                                   <option>one</option>
                                   <option>one</option>
                                   <option>one</option>
                                </select>
                             </div>
                          </form>
                       </div>
                    </div>
                    <div class="col-md-6">
                       <div class="card-body">
                          <form>
                             <div class="form-group">
                                <label>Txn Type</label>
                                <input type="text" class="form-control">
                             </div>
                             <div class="form-group">
                                <label>Value Type</label>
                                <select class="form-control">
                                   <option>one</option>
                                   <option>one</option>
                                   <option>one</option>
                                </select>
                             </div>
                             <div class="form-group">
                                <label>Rel Group</label>
                                <select class="form-control">
                                   <option>one</option>
                                   <option>one</option>
                                   <option>one</option>
                                </select>
                             </div>
                          </form>
                       </div>
                    </div>
                 </div>
                 <!--add and remove-->
                    <div class="row">
                        <div class="col-12">
                            <span class="p-10"><i class="fa fa-plus"></i></span>
                            <span class="p-10"><i class="fa fa-trash"></i></span>

                        </div>
                    </div>
                 <!--end add and remove-->
                    <!--create table-->
                    <table class="table">
                        <tr>
                            <th>Checkbox</th>
                            <th>Rel Level</th>
                            <th>Rel Code</th>
                            <th>Select Employee</th>
                            <th>Approval Min Amount</th>
                            <th>Approval Max Amount</th>
                            <th>Effective Date</th>
                            <th>Expiry Date</th>
                            <th>Payment Term</th>
                        </tr>
                        <tr>
                            <th><input type="checkbox"></th>
                            <th><input type="text" class="form-control"></th>
                            <th><input type="text" class="form-control"></th>
                            <th><input type="text" class="form-control"></th>
                            <th><input type="text" class="form-control"></th>
                            <th><input type="text" class="form-control"></th>
                            <th><input type="date" class="form-control"></th>
                            <th><input type="date" class="form-control"></th>
                            <th>
                                <select class="form-control">
                                    <option>Active</option>
                                    <option>No Active</option>
                                </select>
                            </th>
                        </tr>
                        <tr>
                            <th><input type="checkbox"></th>
                            <th><input type="text" class="form-control"></th>
                            <th><input type="text" class="form-control"></th>
                            <th><input type="text" class="form-control"></th>
                            <th><input type="text" class="form-control"></th>
                            <th><input type="text" class="form-control"></th>
                            <th><input type="date" class="form-control"></th>
                            <th><input type="date" class="form-control"></th>
                            <th>
                                <select class="form-control">
                                    <option>Active</option>
                                    <option>No Active</option>
                                </select>
                            </th>
                        </tr>
                        <tr>
                            <td colspan="9">
                                <button class="btn btn-success btn-sm">Save</button>
                            </td>
                        </tr>
                    </table>
                    <!--end create table-->
                <!--end modal body-->
            </div>
        </div>
    </div>
 </div>
 <!--end Release Strategy modal-->
 